<template>
  <div class="modal-buttons">
    <img
        v-if="gameName == 'morse'"
        :src="require('@/assets/resolution.png')"
        alt=""
        width="150"
        @click="showModal2 = true"
    />
    <img
      @click="showModal = true"
      :src="require(gameName == 'morse' ? '@/assets/morse/resolution.png' : '@/assets/resolution.png')"
      alt=""
      width="150"
    />
  </div>

  <div class="modal" v-if="showModal">
    <div class="modal-mask">
      <div class="modal-container">
        <img class="modal-close" @click="showModal = false" :src="require('@/assets/cancel.svg')" alt="">
        <div class="modal-header">
          <h2 v-if="modal.title">{{ modal.title }}</h2>
          <h3 v-if="modal.description">{{ modal.description }}</h3>
        </div>
        <div class="modal-body" v-if="modal.image">
          <img :src="require('@/assets/' + modal.image)" alt="" />
        </div>
        <div class="modal-footer">
          <p v-if="modal.content" v-html="modal.content"></p>
          <a
            :href="modal.audiofile"
            :download="'' + gameName"
            v-if="modal.audiofile"
          ></a>
        </div>
      </div>
    </div>
  </div>

  <!-- specific morse -->
  <div class="modal" v-if="showModal2">
    <div class="modal-mask">
      <div class="modal-container">
        <img class="modal-close" @click="showModal2 = false" :src="require('@/assets/cancel.svg')" alt="">
        <div class="modal-header">
          <h2 v-if="modal.title">Code morse</h2>
          <h3 v-if="modal.description">Exemple de résolution</h3>
        </div>
        <div class="modal-body">
          <audio src="morse-sample.mp3" controls></audio>
        </div>
        <div class="modal-footer">
          <p>Message final : 5 beaux réseaux<br> ..... / -... . .- ..- -..- / .-. . ... . .- ..- -..-  </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    gameName: String,
    modal: Object,
  },
  data: () => ({
    showModal: false,
    showModal2: false
  }),
};
</script>

<style lang="scss">
.modal {
  &-buttons {
    display: flex;
    margin-top: 5rem;
    height: 20rem;
    flex-direction: column;
    img {
      cursor: pointer;
      @media (max-width: 600px) {
        margin-top: 2rem;
      }
    }
  }
  &-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-container {
    width: 95%;
    box-sizing: border-box;
    max-width: 80rem;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    object-fit: contain;
    text-align: center;
    position: relative;
    .modal {
      &-header {
        line-height: 0.5rem;
        h2 {
          font-size: 2rem;
        }
      }
      &-footer {
        p {
          font-weight: bold;
        }
      }
      &-close {
        width: 1rem;
        position:absolute;
        top:0;
        right: 0;
        margin: 1rem;
        cursor: pointer;
      }
    }
    img {
      width: 100%;
    }
  }
}
</style>

